import { render, staticRenderFns } from "./SystemMenus.vue?vue&type=template&id=2938c2a7&scoped=true"
import script from "./SystemMenus.vue?vue&type=script&lang=js"
export * from "./SystemMenus.vue?vue&type=script&lang=js"
import style0 from "./SystemMenus.vue?vue&type=style&index=0&id=2938c2a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2938c2a7",
  null
  
)

export default component.exports